const UNIT_ARRAY = Object.freeze([]);
const UNIT_OBJECT = Object.freeze({});

export { UNIT_ARRAY, UNIT_OBJECT };
